import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getCurrentEmployee } from '../../services/pinAuthService';
import { getEmployeeBalance } from '../../services/simpleCompService';
import styles from './EmployeeDashboard.module.css';

export const EmployeeDashboard: React.FC = () => {
  const employee = getCurrentEmployee();
  const navigate = useNavigate();

  const { data: balanceResult, isLoading } = useQuery({
    queryKey: ['employee-balance', employee?.id],
    queryFn: () => employee?.id
      ? getEmployeeBalance(employee.id)
      : Promise.resolve({ data: { drinks_available: 0, food_available: 0 }, error: null }),
  });

  if (isLoading) {
    return (
      <div className={styles.loading}>
        Loading...
      </div>
    );
  }

  const balance = balanceResult?.data || { drinks_available: 0, food_available: 0 };
  const totalComps = balance.drinks_available + balance.food_available;

  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <h1>My Balance</h1>
        <p className={styles.welcome}>Hi, {employee?.name?.split(' ')[0]}</p>
      </div>

      {/* Main balance - emphasized */}
      <div className={styles.mainBalance}>
        <div className={styles.mainBalanceValue}>{totalComps}</div>
        <div className={styles.mainBalanceLabel}>Comps Available</div>
      </div>

      {/* Breakdown */}
      <div className={styles.breakdown}>
        <div className={styles.breakdownItem}>
          <span className={styles.breakdownIcon}>🍹</span>
          <span className={styles.breakdownValue}>{balance.drinks_available}</span>
          <span className={styles.breakdownLabel}>Drinks</span>
        </div>
        <div className={styles.breakdownDivider}></div>
        <div className={styles.breakdownItem}>
          <span className={styles.breakdownIcon}>🍕</span>
          <span className={styles.breakdownValue}>{balance.food_available}</span>
          <span className={styles.breakdownLabel}>Food</span>
        </div>
      </div>

      {/* Quick actions */}
      <div className={styles.quickActions}>
        <button
          onClick={() => navigate('/employee/qr')}
          className={styles.primaryButton}
        >
          <span className={styles.buttonIcon}>◎</span>
          <span>Show QR Code</span>
        </button>
        <button
          onClick={() => navigate('/employee/history')}
          className={styles.secondaryButton}
        >
          View History
        </button>
      </div>
    </div>
  );
};
